const state = {
  user:
    JSON.parse(
      localStorage.getItem("user") === "undefined"
        ? "{}"
        : localStorage.getItem("user")
    ) || {}
};

const getters = {
  getUser: () => state.user,
  hasUser: () => Object.keys(state.user).length > 0
};

const actions = {
  updateUser(context, user) {
    localStorage.setItem("user", JSON.stringify(user));
    context.commit("setUser", user);
  },
  logoutUser(context) {
    localStorage.removeItem("user");
    context.commit("removeUser");
  }
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  removeUser(state) {
    state.user = {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
